// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"492":"9e63b076","891":"78185929"}[chunkId] + ".css";
};